const validateClaimBalance = (type, claims) => {

	if (type === "OTHER_CLAIM") {
		return true;
	}

	const claimBalance = claims?.find((o) => o.claimType === type)?.balance || 0;
	return claimBalance > 0;
};

export default validateClaimBalance;
